import { useCallback } from 'react';
import type { ReportParameter } from 'src/components/star-grid/reportDefinition.types';
import { useReportParameter } from 'src/components/star-grid/hooks/useReportParameter';
import { useStudioMultiselect } from 'src/components/star-grid/hooks/useStudioMultiselect';

export const useReportParameterFilter = (
  parameter: ReportParameter,
  values: readonly string[],
  state: ReturnType<typeof useReportParameter>,
  onChange: (key: string, values: readonly string[]) => void
) => {
  const change = useCallback((selected: readonly string[]) => onChange(parameter.key, selected), [parameter.key, onChange]);
  const selection = useStudioMultiselect(
    values,
    (state.data ?? []).map((option) => ({ id: option.value, label: option.label })),
    change
  );
  return {
    ...selection,
    summary: parameter.hierarchy_id && !values.length ? selection.text('selectMembers') : selection.summary,
    title: state.selected.map((option) => option.label).join(', ')
  };
};
